import type { Reducer } from 'redux';
import type { AuditLogState } from '@makemydeal/dr-dash-types';
import type {
    DealAuditLogActions,
    FetchDealChangeLogSuccessAction,
    FetchDealChangeLogFailureAction,
    DownloadAuditLogAction
} from '../actionTypes/dealAuditLogActionTypes';
import {
    DEAL_CHANGE_LOG_REQUEST,
    DEAL_CHANGE_LOG_SUCCESS,
    DEAL_CHANGE_LOG_FAILURE,
    DOWNLOAD_AUDIT_LOG_REQUEST,
    DOWNLOAD_AUDIT_LOG_SUCCESS,
    DOWNLOAD_AUDIT_LOG_FAILURE
} from '../actionTypes/dealAuditLogActionTypes';

const initialState: AuditLogState = {
    auditLogData: [],
    isLoading: false,
    downloadingVersion: ''
};

export type AuditLogReducer = Reducer<AuditLogState>;

export const reducer: AuditLogReducer = (state: AuditLogState = initialState, action: DealAuditLogActions) => {
    switch (action.type) {
        case DEAL_CHANGE_LOG_REQUEST: {
            return {
                ...state,
                error: null,
                isLoading: true,
                printError: false
            };
        }
        case DEAL_CHANGE_LOG_FAILURE: {
            const actionTyped = action as FetchDealChangeLogFailureAction;
            const error = actionTyped.payload && actionTyped.payload.response ? actionTyped.payload.response.error : null;
            return {
                ...state,
                error,
                isLoading: false
            };
        }
        case DEAL_CHANGE_LOG_SUCCESS: {
            const actionTyped = action as FetchDealChangeLogSuccessAction;
            const payload = actionTyped.payload || { auditLogData: [] };
            return {
                ...state,
                isLoading: false,
                ...payload
            };
        }
        case DOWNLOAD_AUDIT_LOG_REQUEST: {
            const actionTyped = action as DownloadAuditLogAction;
            const { version } = actionTyped.payload || {};
            return {
                ...state,
                downloadingVersion: version,
                printError: false
            };
        }
        case DOWNLOAD_AUDIT_LOG_SUCCESS:
        case DOWNLOAD_AUDIT_LOG_FAILURE: {
            return {
                ...state,
                downloadingVersion: '',
                printError: action.type === DOWNLOAD_AUDIT_LOG_FAILURE ? true : false
            };
        }
        default:
            return state;
    }
};
